/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertFormFooterComponent} from './alert-form-footer.component';
import {PipesModule} from '../../../../shared/pipes/pipes.module';
import {BundlesPipesModule} from '../../../../bundles/shared/pipes/bundles-pipes.module';

@NgModule({
    declarations: [AlertFormFooterComponent],
    exports: [
        AlertFormFooterComponent
    ],
    imports: [
        CommonModule,
        PipesModule,
        BundlesPipesModule
    ]
})
export class AlertFormFooterModule {
}
